import React from 'react';
import styled from 'styled-components/macro';
import { AmountDisplay, FiatValueDisplay, useHoldings } from '@onomy/react-hub';

import { responsive } from 'theme/constants';

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 32px 40px;

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;
  }

  @media screen and (max-width: ${responsive.smartphone}) {
    padding: 20px;
  }
`;

const FooterBalance = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  font-size: 14px;
  color: ${props => props.theme.colors.txtSecondary};
`;

const FooterBalanceValue = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  > strong {
    font-size: 28px;
    font-family: Bebas Neue, sans-serif;
    font-weight: 600;
    color: #e1dfeb;
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export default function ValidatorFooter({
  children,
  hideBalance = false,
}: {
  children: React.ReactNode;
  hideBalance?: boolean;
}) {
  const { nomAvailable, loadingStatus } = useHoldings();

  if (loadingStatus.pending) return <Footer />;
  return (
    <Footer>
      <FooterBalance>
        {!hideBalance && (
          <>
            <p>Available NOM</p>
            <FooterBalanceValue>
              <strong>
                <AmountDisplay balance={nomAvailable} SymbolComponent={null} decimalPlaces={3} />
              </strong>
              <span>
                <FiatValueDisplay value={nomAvailable.fiatValue} />
              </span>
            </FooterBalanceValue>
          </>
        )}
      </FooterBalance>
      <Controls>{children}</Controls>
    </Footer>
  );
}
